"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./Select.pc.css");
const Wrapper = ({ className, testId, secondary, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_e7db2bf1', '_7d15c023', '_pub-7d15c023', '_pub-3c25d522', '_7d15c023_wrapper', '_pub-7d15c023_wrapper', '_pub-3c25d522_wrapper', 'wrapper', {
            '_7d15c023_secondary_field_input _pub-7d15c023_secondary_field_input _pub-3c25d522_secondary_field_input secondary_field_input': secondary,
        }, className), "data-testid": testId }, children));
};
exports.Wrapper = Wrapper;
//# sourceMappingURL=Select.pc.js.map